import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AcademicCapIcon, ArrowRightIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import RecruitmentStatus from '../registrations/RecruitmentStatus';

const statusTone = (status) => {
  if (['approved', 'verified', 'placed', 'placement_active', 'placement_completed', 'completed'].includes(status)) return 'positive';
  if (status?.includes('failed') || status === 'rejected') return 'negative';
  if (status === 'withdrawn') return 'muted';
  return status === 'applied' ? 'info' : 'pending';
};

export default function DashboardRegistrations({ registrations, formatDate, canWithdraw, onUpload, onWithdraw }) {
  const [showAll, setShowAll] = useState(false);
  const visibleRegistrations = showAll ? registrations : registrations.slice(0, 3);

  return (
    <section className="learner-panel" aria-labelledby="learner-registrations-title">
      <header className="learner-panel-heading">
        <h2 id="learner-registrations-title">Course registrations</h2>
        <p>Manage your applications and documents.</p>
      </header>
      {registrations.length ? (
        <div className="learner-registration-list">
          {visibleRegistrations.map(registration => (
            <article className={`learner-registration ${registration.status === 'verification_pending' ? 'is-review' : ''}`} key={registration.id}>
              <div className="learner-registration-identity">
                <div className="learner-course-symbol" aria-hidden="true"><AcademicCapIcon /></div>
                <div className="learner-registration-copy">
                  <div className="learner-registration-title-row">
                    <h3><Link to={`/courses/${registration.course?.id}`}>{registration.course?.programme_name || 'Linked course'}</Link></h3>
                    <span className={`learner-status learner-status--${statusTone(registration.status)}`}>{registration.status_display}</span>
                  </div>
                  <p>{registration.course?.campus?.name || 'Campus pending'}</p>
                  <p>Applied on {formatDate(registration.application_date)}</p>
                </div>
              </div>
              <RecruitmentStatus status={registration.status} registration={registration} />
              <div className="learner-registration-actions">
                {['applied', 'verification_pending', 'verification_failed'].includes(registration.status) ? (
                  <button type="button" className="learner-button learner-button--navy" onClick={event => onUpload(event, registration.id)}>
                    <DocumentTextIcon aria-hidden="true" />Manage documents
                  </button>
                ) : null}
                {canWithdraw(registration.status) ? (
                  <button type="button" className="learner-button learner-button--danger" onClick={event => onWithdraw(event, registration)}>Withdraw</button>
                ) : null}
                <Link className="learner-text-link" to={`/courses/${registration.course?.id}`}>Course details <ArrowRightIcon aria-hidden="true" /></Link>
              </div>
            </article>
          ))}
          {registrations.length > 3 ? (
            <button type="button" className="learner-list-toggle" aria-expanded={showAll} onClick={() => setShowAll(value => !value)}>
              {showAll ? 'Show fewer applications' : `Show all ${registrations.length} applications`} <ArrowRightIcon />
            </button>
          ) : null}
        </div>
      ) : (
        <div className="learner-empty-state">
          <AcademicCapIcon aria-hidden="true" />
          <h3>Build your training pathway</h3>
          <p>Your course applications will appear here.</p>
          <Link to="/courses" className="learner-button learner-button--gold">Browse courses</Link>
        </div>
      )}
    </section>
  );
}
